import React, { useState, useRef } from "react"
import * as styles from "./HeroSection.module.css"
import EdgeLogo from "../../images/on-going-projects/the-edge/gallery/edge-logo.png";
import Banner from "../../images/on-going-projects/the-edge/gallery/03.png";
import EdgeRera from "../../images/on-going-projects/the-edge/rera-certificate.pdf";
import Edgebroucher from "../../images/on-going-projects/the-edge/edge-broucher.pdf";
import ReraModal from "../projects/enchanted/ReraModal";
import BrochureModal from "../projects/enchanted/BrochureModal";
import VideoModal from "../projects/enchanted/VideoModal";


const HeroSection = () => {
  const [showReraModal, setShowReraModal] = useState(false);
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const brochurePdfUrlRef = useRef(null);

  return (
    <>
      <section className={styles.newHero}>
        <a href={Edgebroucher} ref={brochurePdfUrlRef} style={{ display: "none" }} download />
        <div className={styles.newHeroInner}>
          {/* LEFT TEXT + LOGO */}
          <div className={styles.newHeroContent}>
            {/* LOGO */}
            <div className={styles.newHeroLogo}>
              <img
                src={EdgeLogo}
                alt="The Edge Logo"
              />
            </div>

            {/* <p className={styles.newHeroKicker}>
              Padmavathy Thayar Street<br />
              Gopalapuram
            </p> */}

            <h1 className={styles.newHeroTitle}>
              A SPARKLING LIFESTYLE THAT PUTS MOST LUXURY HOMES IN THE SHADE
            </h1>

            <p className={`${styles.pdfTrigger} ${styles.newPdfBtn}`} style={{ cursor: 'pointer' }} onClick={() => setShowBrochureModal(true)}>
              E BROCHURE
            </p>
            <br />

            <p className={`${styles.pdfTrigger} ${styles.newPdfBtn}`} style={{ cursor: 'pointer' }} onClick={() => setShowReraModal(true)}>
              TNRERA/29/BLG/0387/2025
            </p>
            <p>
              www.rera.tn.gov.in
            </p>

          </div>


          {/* RIGHT IMAGE + PLAY BUTTON */}
          <div className={styles.newHeroImage}>
            <img
              src={Banner}
              alt="Building"
            />

            {/* PLAY BUTTON */}
            <div className={styles.playBtn} style={{ cursor: 'pointer' }} onClick={() => setShowVideoModal(true)}>
              ▶
            </div>

          </div>
        </div>
      </section>

      <ReraModal
        showReraModal={showReraModal}
        setShowReraModal={setShowReraModal}
        pdfUrl={EdgeRera}
      />

      <BrochureModal
        showBrochureModal={showBrochureModal}
        setShowBrochureModal={setShowBrochureModal}
        brochurePdfUrlRef={brochurePdfUrlRef}
        pdfUrl={Edgebroucher}
        scriptUrl={'https://script.google.com/macros/s/AKfycbykS9v9vMDalOUWVGsbJ9naW6PiNJqrzype9SZ2_nRqNCveAZsfv2BdxpwK5qZPLUx7/exec'}
      />

      <VideoModal
        showVideoModal={showVideoModal}
        setShowVideoModal={setShowVideoModal}
        videoUrl={'https://www.youtube.com/embed/SfJddIS3reI?autoplay=1'}
      />

    </>
  )
}

export default HeroSection
